import { IConcreteDesignImperial } from '@/modules/design/interfaces/newConcrete';
import { UnitSystem } from '@/interfaces/units';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';
import { DesignScenarioType, EsalCalculationMethods } from '@/modules/design/interfaces/shared';
import { IProjectMetadata } from '@/interfaces/report';
import {userStore} from "@/store/store";

export const createNewConcreteScenario = function (project: IProjectMetadata): IConcreteDesignImperial {
  return {
    id: -1,
    user: userStore.user ? userStore.user.id : null,
    project: project.id,
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),
    visible: true,
    displayUnits: project.displayUnits,
    unitSystem: UnitSystem.Imperial,
    scenarioType: BaseScenarioType.design,
    designScenarioType: DesignScenarioType.concrete,
    isComputedFromLegacy: false,

    name: 'New Rigid Pavement Design',
    description: null,
    state: project.state,

    completionYear: new Date(Date.now()).getFullYear(),
    roadwayClassification: null,

    // Pavement Design
    pavementType: null,

    // Design Parameters
    designPeriod_years: null, // Years
    reliabilityLevel: null,
    standardError: 0.5,
    initialServiceability: 4.5,
    terminalServiceability: 2,
    deltaServiceability: null,
    nearestCity: null,

    // Traffic and Loading
    esalCalculatedFrom: EsalCalculationMethods.design,
    // From AADT
    initialTraffic: null,
    trafficGrowthRate: null,
    esalGrowthRate: null,

    // From ESALs
    esals: null,
    loadEquivalencyFactor: null,

    // From Design ESALs
    totalDesignEsals: null,

    // Pavement Structure

    // Pavement Structure
    loadTransferCoefficient: 3,
    poissonsRatio: 0.3,

    edgeSupport: 1.01,

    // Pavement Substructure
    baseLayerType: null,
    drainageFactor: 1.2,
    slabFrictionCoefficient: null,


    // Imperial units

    meanWindSpeed_mph: null,
    meanTemp_degF: null,
    meanPrecip_in: null,

    ruptureModulus_psi: 800,
    elasticModulus_psi: 4000000,
    jointSpacing_in: 170,

    baseModulus_psi: 250,
    baseThickness_in: 6.5,

    subgradeReactionModulus_psiPerIn: null,
  };
};
